"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCardProductBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var helpers_2 = require("../../../common/helpers");
var helpers_3 = require("../../../common/helpers");
var bc_card_product_config_1 = require("./bc-card-product-config");
var bc_card_product_constants_1 = require("./bc-card-product-constants");
var bc_card_product_constants_2 = require("./bc-card-product-constants");
var bc_card_product_constants_3 = require("./bc-card-product-constants");
var bc_card_product_constants_4 = require("./bc-card-product-constants");
var bc_card_product_constants_5 = require("./bc-card-product-constants");
var bc_card_product_constants_6 = require("./bc-card-product-constants");
var bc_card_product_constants_7 = require("./bc-card-product-constants");
var bc_card_product_constants_8 = require("./bc-card-product-constants");
var bc_card_product_constants_9 = require("./bc-card-product-constants");
var bc_card_product_constants_10 = require("./bc-card-product-constants");
var bc_card_product_constants_11 = require("./bc-card-product-constants");
var bc_card_product_constants_12 = require("./bc-card-product-constants");
var bc_card_product_constants_13 = require("./bc-card-product-constants");
var bc_card_product_constants_14 = require("./bc-card-product-constants");
var bc_card_product_constants_15 = require("./bc-card-product-constants");
var bc_card_product_constants_16 = require("./bc-card-product-constants");
var bc_card_product_constants_17 = require("./bc-card-product-constants");
var bc_card_product_constants_18 = require("./bc-card-product-constants");
var bc_card_product_constants_19 = require("./bc-card-product-constants");
var bc_card_product_constants_20 = require("./bc-card-product-constants");
var bc_card_product_constants_21 = require("./bc-card-product-constants");
var bc_card_product_constants_22 = require("./bc-card-product-constants");
var bc_card_product_constants_23 = require("./bc-card-product-constants");
var BcCardProductBehavior = (function (_super) {
    __extends(BcCardProductBehavior, _super);
    function BcCardProductBehavior() {
        var _this = _super.call(this) || this;
        _this.toggleIcon = null;
        _this.config = null;
        _this.active = false;
        _this.cardBody = null;
        _this.onceToggleAction = false;
        return _this;
    }
    BcCardProductBehavior.prototype._setUp = function () {
        this.getElements();
        this.setEventListeners();
    };
    BcCardProductBehavior.prototype.build = function () {
        this.isReady = false;
        this.bodySectionBuilder();
        this.cardHeadBuilder();
        this.cardDescriptionsBuilder();
        this.cardInfoContainerBuilder();
        this.cardTitleBalanceBuilder();
        this.cardStausBuilder();
        switch (this.toEnumValue(this.config.cardType)) {
            case bc_card_product_config_1.BcCardType['small-img']:
                this.imgSectionBuilder();
                break;
            case bc_card_product_config_1.BcCardType["none-icon"]:
                this.cardBalanceBuilder();
                break;
            case bc_card_product_config_1.BcCardType.small:
                this.iconSectionBuilder();
                break;
            default:
                this.iconSectionBuilder();
                this.cardBalanceBuilder();
                break;
        }
        this.cardAddtionalText();
        this.isReady = true;
    };
    BcCardProductBehavior.prototype.setActive = function (status) {
        this.active = status;
        if (status) {
            (0, helpers_1.replaceClass)(this.toggleIcon, bc_card_product_constants_10.CARD_TOGGLE_CLASS, bc_card_product_constants_11.CARD_TOGGLE_ACTIVE_CLASS);
        }
        else {
            (0, helpers_1.replaceClass)(this.toggleIcon, bc_card_product_constants_11.CARD_TOGGLE_ACTIVE_CLASS, bc_card_product_constants_10.CARD_TOGGLE_CLASS);
        }
    };
    BcCardProductBehavior.prototype.setConfig = function (config) {
        this.config = config;
        this.initConfiguration();
        this.getType();
    };
    BcCardProductBehavior.prototype.getConfig = function () {
        this.getType();
        this.getIconConfig();
        this.getSutittleConfig();
        this.getTitleBalanceConfig();
        this.getStatusConfig();
        this.getBalanceConfig();
        this.getAdditionalTextConfig();
        if (this.toggleIcon) {
            this.config.icon = this.toggleIcon;
        }
        return this.config;
    };
    BcCardProductBehavior.prototype.initConfiguration = function () {
        if (!this.config) {
            this.config = {
                value: new Date().getMilliseconds(),
                cardType: bc_card_product_config_1.BcCardType["none-icon"],
                tittle: this.getCardTittle(),
            };
        }
    };
    BcCardProductBehavior.prototype.getElements = function () {
        this.getToggle();
        this.getCardBody();
    };
    BcCardProductBehavior.prototype.getCardTittle = function () {
        var tittle = this.mySelf.querySelector("*[class~='".concat(bc_card_product_constants_9.CARD_TITTLE_CLASS, "']"));
        if (tittle) {
            return tittle.innerHTML;
        }
        return "";
    };
    BcCardProductBehavior.prototype.getCardBody = function () {
        var bodyContainer = this.mySelf.querySelector("*[class~='".concat(bc_card_product_constants_7.CARD_BODY_CLASS, "']"));
        if (bodyContainer) {
            this.cardBody = bodyContainer;
        }
    };
    BcCardProductBehavior.prototype.getToggle = function () {
        var toggleIcon = this.mySelf.querySelector(".".concat(bc_card_product_constants_10.CARD_TOGGLE_CLASS, ", .").concat(bc_card_product_constants_11.CARD_TOGGLE_ACTIVE_CLASS));
        if (toggleIcon) {
            this.toggleIcon = toggleIcon;
        }
    };
    BcCardProductBehavior.prototype.getType = function () {
        var _this = this;
        if (!this.config) {
            this.initConfiguration();
        }
        this.mySelf.classList.forEach(function (c) {
            var _type = _this.toEnumValue(c.replace("".concat(bc_card_product_constants_1.CARD_CLASS, "-"), ''));
            if (_type) {
                _this.config.cardType = _type;
            }
        });
    };
    BcCardProductBehavior.prototype.setEventListeners = function () {
        var _this = this;
        if (this.toggleIcon && this.toggleAction) {
            var eventClick = function (e) {
                if (_this.disabled) {
                    return;
                }
                _this.toggleAction(e);
                e.target.setAttribute('listener', 'true');
            };
            if (this.toggleIcon.getAttribute('listener') !== 'true') {
                this.toggleIcon.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, eventClick);
                (0, helpers_3.addFocusable)(this.toggleIcon, {}, { event: this.toggleAction });
            }
        }
        if (this.clickAction) {
            this.mySelf.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                if (_this.disabled) {
                    return;
                }
                _this.clickAction(event);
            });
        }
    };
    BcCardProductBehavior.prototype.cardTitleBalanceBuilder = function () {
        if (this.config.titleBalance) {
            this.infoDivAppend((0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.P_TAG,
                classList: [bc_card_product_constants_1.CARD_INFO_TITLE_BALANCE_CLASS],
                innerText: this.config.titleBalance,
            }));
        }
    };
    BcCardProductBehavior.prototype.cardAddtionalText = function () {
        if (this.config.additionalText) {
            this.infoDivAppend((0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.P_TAG,
                classList: [bc_card_product_constants_17.CARD_INFO_ADITIOAL_TEXT_CLASS],
                innerText: this.config.additionalText,
            }));
        }
    };
    BcCardProductBehavior.prototype.cardBalanceBuilder = function () {
        this.infoDivAppend((0, helpers_2.createElement)({
            element: common_constants_1.BcCommonConstants.H6_TAG,
            classList: [bc_card_product_constants_16.CARD_INFO_BALANCE_CLASS],
            innerText: this.config.balance,
        }));
    };
    BcCardProductBehavior.prototype.cardStausBuilder = function () {
        if (this.config.statusComponentClassList) {
            var elementsStatus = void 0;
            if (this.config.statusComponentIcon && this.config.statusComponentClassList.includes(bc_card_product_constants_3.STATUS_ICON_LEFT_CLASS)) {
                elementsStatus = this.createIconLeft();
            }
            else if (this.config.statusComponentIcon && this.config.statusComponentClassList.includes(bc_card_product_constants_4.STATUS_ICON_RIGHT_CLASS)) {
                elementsStatus = this.createIconRight();
            }
            else {
                elementsStatus = [
                    (0, helpers_2.createElement)({
                        element: common_constants_1.BcCommonConstants.SPAN_TAG,
                        innerText: this.config.statusComponentText
                    })
                ];
            }
            var status_1 = (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.DIV_TAG,
                classList: __spreadArray([], this.config.statusComponentClassList, true),
                children: elementsStatus
            });
            this.infoDivAppend(status_1);
        }
    };
    BcCardProductBehavior.prototype.createIconLeft = function () {
        return [
            (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.I_TAG,
                classList: [common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_SM_CLASS],
                innerText: this.config.statusComponentIcon
            }),
            (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.SPAN_TAG,
                innerText: this.config.statusComponentText
            }),
        ];
    };
    BcCardProductBehavior.prototype.createIconRight = function () {
        return [
            (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.SPAN_TAG,
                innerText: this.config.statusComponentText
            }),
            (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.I_TAG,
                classList: [common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_SM_CLASS],
                innerText: this.config.statusComponentIcon
            }),
        ];
    };
    BcCardProductBehavior.prototype.infoDivAppend = function (element) {
        var infoDIv = this.cardBody.querySelector("*[class~='".concat(bc_card_product_constants_15.CARD_INFO_CLASS, "']"));
        if (infoDIv) {
            infoDIv.appendChild(element);
        }
    };
    BcCardProductBehavior.prototype.cardInfoContainerBuilder = function () {
        var divInfo = (0, helpers_2.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_product_constants_15.CARD_INFO_CLASS],
        });
        if (this.cardBody) {
            this.cardBody.appendChild(divInfo);
        }
    };
    BcCardProductBehavior.prototype.cardDescriptionsBuilder = function () {
        var bodyContainer = this.mySelf.querySelector("*[class~='".concat(bc_card_product_constants_7.CARD_BODY_CLASS, "']"));
        var subTitleClass = this.getSizeClass().subtittleClass;
        var subTitleDescriptionClass = this.getSizeClass().subtittleDescriptionClass;
        if (bodyContainer) {
            var subtittle = (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.P_TAG,
                classList: [subTitleClass],
            });
            var subtittleDescription = (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.P_TAG,
                classList: [subTitleDescriptionClass],
            });
            var details = this.config.subtittle;
            if (details) {
                if (typeof details === "string") {
                    subtittle.innerText = details;
                }
                else {
                    subtittle.innerText = details[0];
                    subtittleDescription.innerText = details[1];
                }
                bodyContainer.appendChild(subtittle);
                bodyContainer.appendChild(subtittleDescription);
            }
        }
    };
    BcCardProductBehavior.prototype.getSizeClass = function () {
        var size = { titleClass: bc_card_product_constants_9.CARD_TITTLE_CLASS, subtittleClass: bc_card_product_constants_13.CARD_SUBTITTLE_CLASS, subtittleDescriptionClass: bc_card_product_constants_14.CARD_SUBTITTLE_DESCRIPTION_CLASS };
        switch (this.config.size) {
            case bc_card_product_config_1.BcCardProductSizeFont.normal:
                size.titleClass = bc_card_product_constants_9.CARD_TITTLE_CLASS;
                size.subtittleClass = bc_card_product_constants_13.CARD_SUBTITTLE_CLASS;
                size.subtittleDescriptionClass = bc_card_product_constants_14.CARD_SUBTITTLE_DESCRIPTION_CLASS;
                break;
            case bc_card_product_config_1.BcCardProductSizeFont.medium:
                size.titleClass = bc_card_product_constants_18.CARD_TITTLE_MEDIUM_CLASS;
                size.subtittleClass = bc_card_product_constants_20.CARD_SUBTITTLE_MEDIUM_CLASS;
                size.subtittleDescriptionClass = bc_card_product_constants_22.CARD_SUBTITTLE_DESCRIPTION_MEDIUM_CLASS;
                break;
            case bc_card_product_config_1.BcCardProductSizeFont.large:
                size.titleClass = bc_card_product_constants_19.CARD_TITTLE_LARGE_CLASS;
                size.subtittleClass = bc_card_product_constants_21.CARD_SUBTITTLE_LARGE_CLASS;
                size.subtittleDescriptionClass = bc_card_product_constants_23.CARD_SUBTITTLE_DESCRIPTION_LARGE_CLASS;
                break;
            default:
                size.titleClass = bc_card_product_constants_9.CARD_TITTLE_CLASS;
                size.subtittleClass = bc_card_product_constants_13.CARD_SUBTITTLE_CLASS;
                size.subtittleDescriptionClass = bc_card_product_constants_14.CARD_SUBTITTLE_DESCRIPTION_CLASS;
        }
        return size;
    };
    BcCardProductBehavior.prototype.cardHeadBuilder = function () {
        var titleClass = this.getSizeClass().titleClass;
        if (this.cardBody) {
            var head = (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.DIV_TAG,
                classList: [bc_card_product_constants_8.CARD_HEAD_CLASS],
                children: [
                    (0, helpers_2.createElement)({
                        element: common_constants_1.BcCommonConstants.H6_TAG,
                        classList: [titleClass],
                        innerText: this.config.tittle,
                    }),
                ]
            });
            var toggle = this.config.toggleIcon || (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.EM_TAG,
                classList: [
                    this.active ?
                        bc_card_product_constants_11.CARD_TOGGLE_ACTIVE_CLASS :
                        bc_card_product_constants_10.CARD_TOGGLE_CLASS,
                    common_constants_1.BcCommonConstants.ICONS_CLASS,
                    bc_card_product_constants_12.CARD_TOGGLE_ACTIVE_DIRECTION_CLASS
                ],
                props: {
                    'aria-hidden': 'true',
                },
            });
            this.toggleIcon = toggle;
            head.appendChild(toggle);
            this.cardBody.appendChild(head);
        }
    };
    BcCardProductBehavior.prototype.iconSectionBuilder = function () {
        var iconSection = (0, helpers_2.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_product_constants_5.CARD_ICON_LEADING_ICON_CLASS],
            children: [
                (0, helpers_2.createElement)({
                    element: common_constants_1.BcCommonConstants.EM_TAG,
                    classList: [common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_XL_CLASS],
                    props: {
                        'aria-hidden': 'true',
                    },
                    innerText: this.config.icon || 'e-card'
                })
            ]
        });
        this.mySelf.prepend(iconSection);
    };
    BcCardProductBehavior.prototype.imgSectionBuilder = function () {
        var imgSection = (0, helpers_2.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_product_constants_6.CARD_ICON_LEADING_IMG_CLASS],
            children: [
                (0, helpers_2.createElement)({
                    element: common_constants_1.BcCommonConstants.IMG_TAG,
                    classList: [common_constants_1.BcCommonConstants.ICONS_CLASS],
                    props: {
                        'alt': this.config.icon,
                        'src': "/assets/icons/".concat(this.config.typeIcon, "/").concat(this.config.icon, ".svg")
                    },
                })
            ]
        });
        this.mySelf.prepend(imgSection);
    };
    BcCardProductBehavior.prototype.bodySectionBuilder = function () {
        var bodyContainer = (0, helpers_2.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_product_constants_7.CARD_BODY_CLASS],
        });
        this.mySelf.appendChild(bodyContainer);
        this.getCardBody();
    };
    BcCardProductBehavior.prototype.toEnumValue = function (enumValue) {
        if (typeof enumValue === 'string') {
            var enumType = enumValue;
            return bc_card_product_config_1.BcCardType[enumType];
        }
        return enumValue;
    };
    BcCardProductBehavior.prototype.getIconConfig = function () {
        var iconClass = bc_card_product_constants_5.CARD_ICON_LEADING_ICON_CLASS;
        if (this.config.cardType === bc_card_product_config_1.BcCardType["small-img"]) {
            iconClass = bc_card_product_constants_6.CARD_ICON_LEADING_IMG_CLASS;
        }
        var icon = this.mySelf.querySelector("div.".concat(iconClass, " > em"));
        if (icon) {
            this.config.icon = icon;
        }
    };
    BcCardProductBehavior.prototype.getSutittleConfig = function () {
        var subtittle = this.cardBody.querySelector("*[class~='".concat(bc_card_product_constants_13.CARD_SUBTITTLE_CLASS, "']"));
        var subtittleDescription = this.cardBody.querySelector("*[class~='".concat(bc_card_product_constants_14.CARD_SUBTITTLE_DESCRIPTION_CLASS, "']"));
        if (subtittle) {
            this.config.subtittle = subtittle.innerHTML;
            if (subtittleDescription) {
                this.config.subtittle = [subtittle.innerHTML, subtittleDescription.innerHTML];
            }
        }
    };
    BcCardProductBehavior.prototype.getStatusConfig = function () {
        var statusDiv = this.cardBody.querySelector("".concat(common_constants_1.BcCommonConstants.DIV_TAG, ".").concat(bc_card_product_constants_2.STATUS_CLASS));
        if (statusDiv) {
            var list = statusDiv.classList.value;
            this.config.statusComponentClassList = list.split(" ");
            var statusText = statusDiv.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
            if (statusText) {
                this.config.statusComponentText = statusText.innerHTML;
            }
            var statusIcon = statusDiv.querySelector(".".concat(common_constants_1.BcCommonConstants.ICONS_CLASS));
            if (statusIcon) {
                this.config.statusComponentIcon = statusIcon.innerHTML;
            }
        }
    };
    BcCardProductBehavior.prototype.getBalanceConfig = function () {
        var balance = this.cardBody.querySelector("*[class~='".concat(bc_card_product_constants_16.CARD_INFO_BALANCE_CLASS, "']"));
        if (balance) {
            this.config.balance = balance.innerHTML;
        }
    };
    BcCardProductBehavior.prototype.getTitleBalanceConfig = function () {
        var titleBalance = this.cardBody.querySelector("*[class~='".concat(bc_card_product_constants_1.CARD_INFO_TITLE_BALANCE_CLASS, "']"));
        if (titleBalance) {
            this.config.titleBalance = titleBalance.innerHTML;
        }
    };
    BcCardProductBehavior.prototype.getAdditionalTextConfig = function () {
        var additionalText = this.cardBody.querySelector("*[class~='".concat(bc_card_product_constants_17.CARD_INFO_ADITIOAL_TEXT_CLASS, "']"));
        if (additionalText) {
            this.config.additionalText = additionalText.innerHTML;
        }
    };
    return BcCardProductBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcCardProductBehavior = BcCardProductBehavior;
